// src/components/SocialIcons.jsx
import React from 'react';
import '../SocialIcons.css'; // Make sure this file contains styles

const SocialIcons = () => {
    return (
        <div className="social-icons">
            {/* <a
                href="https://www.facebook.com/share/16XbSgEsqX/"
                className="icon facebook"
                aria-label="Facebook"
                target="_blank"
                rel="noopener noreferrer"
            >
                <i className="fab fa-facebook-f"></i>
            </a> */}

            <a
                href="https://www.instagram.com/lavanyainfotech_official_?igsh=YzUzNnNqbmR1bTQ4"
                className="icon instagram"
                aria-label="Instagram"
                target="_blank"
                rel="noopener noreferrer"
            >
                <i className="fab fa-instagram"></i>
            </a>

            <a
                href="https://x.com/Info_lavanya_"
                className="icon twitter"
                aria-label="Twitter"
                target="_blank"
                rel="noopener noreferrer"
            >
                <i className="fab fa-twitter"></i>
            </a>

            {/* <a
        href="#"
        className="icon linkedin"
        aria-label="LinkedIn"
        target="_blank"
        rel="noopener noreferrer"
      >
        <i className="fab fa-linkedin-in"></i>
      </a> */}
        </div>
    );
};

export default SocialIcons;
